import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { copyExistingScenarioToNewScenario } from 'scaleflow/routes/roadmap/strategy/create';
import { getNextQuarterDates } from 'scaleflow/utils/next-quarter-dates';
import RoadmapValidations from 'scaleflow/validators/roadmap';

export default class QuickAddsRoadmapComponent extends Component {
  @service store;
  @service router;
  @service intl;

  roadmap = {
    title: '',
  };
  roadmapValidations = RoadmapValidations;

  @action
  async onSubmit(changeset, e) {
    e.preventDefault();
    try {
      await changeset.validate();
      if (changeset.isInvalid) {
        console.debug(changeset.errors);
        return;
      }
      //get next quarter dates
      const { start: start_date, end: end_date } = getNextQuarterDates();

      //derive scenario to attach
      const scenario = await this.deriveScenarioToAttach(changeset.title);
      const roadmap = this.store.createRecord('roadmap', {
        title: changeset.title,
        start_date,
        end_date,
        'investment-scenario': scenario,
      });
      await roadmap.save();
      this.args?.onItemSaved(roadmap);
      this.handleModalDismiss();
    } catch (err) {
      console.log(err);
    }
  }

  /**
   * If a scenario is already provided (like when within the roadmap dashobard page), attach that scenario
   * else choose the first scenario from the store, clone it, and then attach it
   * @param {String} roadmap_title
   * @returns scenario
   */
  async deriveScenarioToAttach(roadmap_title) {
    let scenario;
    if (this.args.scenario) {
      scenario = this.args.scenario;
    } else {
      const _scenario = this.store.peekAll('investment-scenario')[0];
      scenario = copyExistingScenarioToNewScenario.call(this, _scenario);
      scenario.title = `${this.intl.t('_scenarios.title', { num: 1 })} - ${roadmap_title}`;
      await scenario.save();
    }
    return scenario;
  }

  @action
  handleModalDismiss() {
    this.args?.handleFormDismiss();
  }
}
